import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GiftAidImport } from '@app/core/Store';
import { Store } from '@ngxs/store';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-gift-aid-donations-details',
  templateUrl: './gift-aid-donations-details.component.html',
  styleUrls: ['./gift-aid-donations-details.component.scss'],
})
export class GiftAidDonationsDetailsComponent {
  displayedColumns: any[] = [];
  dataSource = new MatTableDataSource<any>([]);

  @Input() giftAidImportData: any[] = [];
  @ViewChild('donationsPaginator') paginator: MatPaginator;

  constructor(private store: Store, private spinner: NgxSpinnerService) {}

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnChanges() {
    this.spinner.show();
    this.getList();
  }

  getList(): void {
    const data = this.giftAidImportData || [];
    this.dataSource = new MatTableDataSource<any>(data);
    if (data.length > 0) {
      this.displayedColumns = Object.keys(data[0]);
    }
    this.dataSource.paginator = this.paginator;
    this.spinner.hide();
  }
}
